import BatchPage from 'pages/Batch';

import { getRoute } from 'utils/routes';

import useTrackPageViews from 'services/dataDog/useTrackPageViews';
import { useRouter } from '../RoutesProvider';

function AppRoutes() {
  useTrackPageViews();

  // @ts-ignore
  const { pathname, routes } = useRouter();

  const getRenderPage = (path: any) => {
    const route = getRoute(path);

    if (route === routes?.base.path) {
      return <BatchPage />;
    }

    return <BatchPage />;
  };

  const view = getRenderPage(pathname);

  return <>{view}</>;
}

export default AppRoutes;
